export default __webpack_public_path__ + "static/media/compass_connection.e51975db.PNG";